// extracted by mini-css-extract-plugin
export default {"page":"fX-z","cartModal":"gX-z","checkout":"hX-z","placeholder":"iX-z","account":"jX-z"};